import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import {
  NgxMatDatepickerActions,
  NgxMatDatepickerApply,
  NgxMatDatepickerCancel,
  NgxMatDatepickerInput,
  NgxMatDatepickerToggle,
  NgxMatDatetimepicker,
} from '@ngxmc/datetime-picker';
import { UiActivityColorComponent } from './ui-activity-color/ui-activity-color.component';
import { UiAutocompleteComponent } from './ui-autocomplete/ui-autocomplete.component';
import { UiButtonComponent } from './ui-button/ui-button.component';
import { UiCheckboxComponent } from './ui-checkbox/ui-checkbox.component';
import { UiChipComponent } from './ui-chip/ui-chip.component';
import { UiDateRangePickerComponent } from './ui-date-range-picker/ui-date-range-picker.component';
import { UiDatepickerComponent } from './ui-datepicker/ui-datepicker.component';
import { UiListComponent } from './ui-list/ui-list.component';
import { UiListSelectComponent } from './ui-list-select/ui-list-select.component';
import { UiPillComponent } from './ui-pill/ui-pill.component';
import { UiRadioGroupComponent } from './ui-radio-group/ui-radio-group.component';
import { UiSelectGroupComponent } from './ui-select-group/ui-select-group.component';
import { UiSlideToggleComponent } from './ui-slide-toggle/ui-slide-toggle.component';
import { UiTableSelectionComponent } from './ui-table-selection/ui-table-selection.component';
import { UiTextAreaComponent } from './ui-text-area/ui-text-area.component';
import { UiTextInputComponent } from './ui-text-input/ui-text-input.component';
import { ErrorMessagesPipe } from '../pipes/error-messages.pipe';
import { MaterialModule } from '../../modules/material.module';
import { DepartmentPausedBadgeComponent } from './department-paused-badge/department-paused-badge.component';
import { SharedUiSelectComponent } from './ui-select/ui-select.component';
import { UiChipsAutocompleteComponent } from './ui-chips-autocomplete/ui-chips-autocomplete.component';
import { IsIAttachmentPipe } from '../pipes/is-iattachment.pipe';
import { JoinErrorMessagesPipe } from '../pipes/join-error-messages.pipe';
import { UiMonthpickerComponent } from './ui-monthpicker/ui-monthpicker.component';
import { UiLabelTextComponent } from './ui-label-text/ui-label-text.component';
import { UiTimepickerComponent } from './ui-timepicker/ui-timepicker.component';
import { UiNavigateToPersonComponent } from './ui-navigate-to-person/ui-navigate-to-person.component';
import { UiPhoneInputComponent } from './ui-phone-input/ui-phone-input.component';
import { UiWidgetCardComponent } from './ui-widget-card/ui-widget-card.component';
import { UiStackedBarChartComponent } from './ui-stacked-bar-chart/ui-stacked-bar-chart.component';
import { ActionInProgressPipe } from '../directives/action-in-progress.pipe';
import { AppLoaderDirective } from '../directives/app-loader.directive';
import { HeaderBackButtonDirective } from '../directives/header-back-button.directive';

@NgModule({
  declarations: [
    DepartmentPausedBadgeComponent,
    HeaderBackButtonDirective,
    SharedUiSelectComponent,
    UiActivityColorComponent,
    UiAutocompleteComponent,
    UiButtonComponent,
    UiCheckboxComponent,
    UiChipComponent,
    UiChipsAutocompleteComponent,
    UiDateRangePickerComponent,
    UiDatepickerComponent,
    UiLabelTextComponent,
    UiListComponent,
    UiListSelectComponent,
    UiNavigateToPersonComponent,
    UiPhoneInputComponent,
    UiPillComponent,
    UiRadioGroupComponent,
    UiSelectGroupComponent,
    UiSlideToggleComponent,
    UiTableSelectionComponent,
    UiTextAreaComponent,
    UiTextInputComponent,
    UiMonthpickerComponent,
    UiTimepickerComponent,
    UiWidgetCardComponent,
    UiStackedBarChartComponent,
  ],
  imports: [
    ActionInProgressPipe,
    AppLoaderDirective,
    CommonModule,
    ErrorMessagesPipe,
    IsIAttachmentPipe,
    JoinErrorMessagesPipe,
    MaterialModule,
    NgxMatDatepickerActions,
    NgxMatDatepickerApply,
    NgxMatDatepickerCancel,
    NgxMatDatepickerInput,
    NgxMatDatepickerToggle,
    NgxMatDatetimepicker,
    ReactiveFormsModule,
    TranslateModule,
  ],
  exports: [
    ActionInProgressPipe,
    AppLoaderDirective,
    DepartmentPausedBadgeComponent,
    HeaderBackButtonDirective,
    SharedUiSelectComponent,
    UiActivityColorComponent,
    UiAutocompleteComponent,
    UiButtonComponent,
    UiCheckboxComponent,
    UiChipComponent,
    UiChipsAutocompleteComponent,
    UiDateRangePickerComponent,
    UiDatepickerComponent,
    UiLabelTextComponent,
    UiListComponent,
    UiListSelectComponent,
    UiMonthpickerComponent,
    UiNavigateToPersonComponent,
    UiPhoneInputComponent,
    UiPillComponent,
    UiRadioGroupComponent,
    UiSelectGroupComponent,
    UiSlideToggleComponent,
    UiTableSelectionComponent,
    UiTextAreaComponent,
    UiTextInputComponent,
    UiTimepickerComponent,
    UiWidgetCardComponent,
    UiStackedBarChartComponent,
  ],
})
export class UIElementsModule {}
